import { render, staticRenderFns } from "./AamsRegSealIncidentReport.vue?vue&type=template&id=9a98296e&scoped=true&"
import script from "./AamsRegSealIncidentReport.vue?vue&type=script&lang=js&"
export * from "./AamsRegSealIncidentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a98296e",
  null
  
)

export default component.exports